import {twMerge} from '../../../common/twMerge';
import {SHORTCUT_ICON_MAP} from '../../../domain/menu/constant';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {Text} from '../../atoms/Text/Text';
import {ShortcutButtonProps} from './ShortcutButtonProps.interface';

export function ShortcutButton({
  shortcutIconType,
  shortcutText,
  className,
}: ShortcutButtonProps) {
  return (
    <div
      className={twMerge([
        'flex h-48pxr w-full cursor-pointer items-center rounded-8pxr',
        shortcutIconType
          ? 'bg-theme-solid-10'
          : 'border border-solid border-theme-transparent-20',
        className,
      ])}
    >
      {shortcutIconType && (
        <StaticImage
          imageType={SHORTCUT_ICON_MAP[shortcutIconType]}
          className="ml-5pxr hidden h-36pxr w-36pxr shortcut:block"
        />
      )}
      <Text
        className={twMerge([
          'font-small1-bold ml-15pxr flex-1 text-theme-solid-100 line-clamp-1 shortcut:ml-0',
          !shortcutIconType && 'shortcut:ml-15pxr',
        ])}
      >
        {shortcutText}
      </Text>
      <Icon type={IconType.ButtonArrowRight} className="mr-15pxr" />
    </div>
  );
}
